import request from '@/utils/request'

// 示例：获取用户信息的API
export const getUserInfo = (data) => {
  return request({
    url: '/app/user/selfinfo', // 接口地址
    method: 'post',     // 请求方法
    data             // 请求参数 (for GET)
    // data: params    // 请求体 (for POST, PUT, etc.)
  })
}

// 示例：登录API
export const login = (data) => {
  return request({
    url: '/app/user/login/email', 
    method: 'post',
    data
  })
}
//手机号登录
export const loginByPhone = (data) => {
  return request({
    url: '/app/user/login/phone',
    method: 'post',
    data
  })
}
//ログアウト
export const logout = () => {
  return request({
    url: '/app/logout',
    method: 'post'
  })
}
//记录PVUV
export const recordPVUV = (data) => {
  return request({
    url: '/app/user/open',
    method: 'post',
    data
  })
}
//发送短信验证码
export const sendSmsCode = (data) => {
  return request({
    url: '/app/user/message/code',
    method: 'post',
    data
  })
}
// 发送邮箱验证码
export const sendCode = (data) => {
  return request({
    url: '/app/user/email/code',
    method: 'post',
    data
  })
}
//获取八字详情
export const getZhiBuDetail = (data) => {
  return request({
    url: '/app/paipan',
    method: 'post',
    data
  })
}
//获取订阅列表
export const getSubscribeList = (data) => {
  return request({
    url: '/app/plan/list',
    method: 'post',
    data
  })
}
//下单订阅

export const addSubscribe = (data) => {
  return request({
    url: '/app/plan/create',
    method: 'post',
    data
  })
}
//获取会话列表
export const getChatList = (data) => {
  return request({
    url: '/app/ai/session/list',
    method: 'post',
    data
  })
}
//会话记录
export const getChatRecord = (data) => {
  return request({
    url: '/app/ai/question/list',
    method: 'post',
    data
  })
}
//获取六爻详情
export const getSixYaoDetail = (data) => {
  return request({
    url: '/app/hexagram',
    method: 'post',
    data
  })
}
//获取缓存信息
export const getCacheInfo = (data) => {
  return request({
    url: '/app/plan/cache/get',
    method: 'post',
    data
  }) 
}
//获取区号
export const getAreaCode = (data) => {
  return request({
    url: '/app/message/areacode/list',
    method: 'post',
    data
  })
}
//返佣记录
export const getRebateRecord = (data) => {
  return request({
    url: '/app/agent/commission/list',
    method: 'post',
    data
  })  
}
// 获取断法
export const getDuanfa = (data) => {
  return request({
    url: '/app/df/get/estimate/type',
    method: 'post',
    data
  }) 
}
// 获取断法详情
export const getDuanfaDetail = (data) => {
  return request({
    url: '/app/df/get/estimate/context',
    method: 'post',
    data
  })  
}
// 在这里添加更多的API接口函数...

// 导出所有API函数，方便统一导入
// export default {
//   getUserInfo,
//   login,
//   // ...其他导出的函数
// }